<template>
  <div class="EventTrends">
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
import echarts from "echarts";
import api from "@ISS/situation/api";

export default {
  name: "EventTrends",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const { success, returnObj } = await this.$fetch(api.emergency.statEmergencyByMonth)
      if (success) {
        this.initCharts(returnObj)
      }
    },
    initCharts(data) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const option = {
        color: ['#93BEFF', '#FAC858'],
        tooltip: {
          trigger: "axis",
        },
        xAxis: [
          {
            name: "月",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                // color: "rgba(255,255,255,0.7)",
                color: "#ffffff",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff",
              },
            },
            data: data.map(v => v.statDate),
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                // color: "rgba(255,255,255,0.7)",
                color: "#ffffff",
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "当年事件趋势",
            type: "line",
            symbol: "none",
            lineStyle: {
              width: 2,
              color: '#FF7C3F'
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(218,107,55,0.502)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(106,44,15,0)'
                    },
                  ],
                  false
                )
              },
            },
            data: data.map(v => v.emergencyCount)
          }
        ]
      };
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.EventTrends {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
